import type { UserInformation, AccessLevelType } from "./AuthenticationContext";

enum ActionTypes {
  Login = "Login",
  GrantPermission = "GrantPermission",
  Logout = "Logout",
  ChangeInfo = "ChangeInfo",
}

type IState = {
  userInfo: UserInformation;
  isLogin: boolean;
};

type IAction =
  | {
      type: ActionTypes.Login;
      payload: UserInformation;
    }
  | {
      type: ActionTypes.GrantPermission;
      payload: { access_level: AccessLevelType[]; supplier_list: number[] };
    }
  | {
      type: ActionTypes.ChangeInfo;
      payload: { fullname: string };
    }
  | {
      type: ActionTypes.Logout;
    };

function ReducerFunction(state: IState, action: IAction): IState {
  switch (action.type) {
    case ActionTypes.Login:
      return { userInfo: { ...action.payload }, isLogin: true };
    case ActionTypes.GrantPermission:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          access_level: [...action.payload.access_level],
          supplier_list: [...action.payload.supplier_list],
        },
      };
    case ActionTypes.Logout:
      return {
        userInfo: {
          id: 0,
          token: "",
          fullName: "",
          mobile: "",
          access_level: [],
          supplier_list: [],
        },
        isLogin: false,
      };
    case ActionTypes.ChangeInfo:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          fullName: action.payload.fullname,
        },
      };
    default:
      return state;
  }
}

export default ReducerFunction;
export { ActionTypes };
